// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  firmId: __t.u64().primaryKey().name("firm_id"),
  epoch: __t.u64(),
  cyc: __t.u64(),
  chosen: __t.string(),
  toKey: __t.string().name("to_key"),
  qty: __t.u32(),
  netSov: __t.i64().name("net_sov"),
  perMinX100: __t.i64().name("per_min_x_100"),
  pLossX1000: __t.u32().name("p_loss_x_1000"),
  pLossLoX1000: __t.u32().name("p_loss_lo_x_1000"),
  pLossHiX1000: __t.u32().name("p_loss_hi_x_1000"),
  lost: __t.u32(),
  arrived: __t.u32(),
  rowsJson: __t.string().name("rows_json"),
  stopReason: __t.string().name("stop_reason"),
  shipmentId: __t.u64().name("shipment_id"),
  decidedAt: __t.timestamp().name("decided_at"),
});
